/**
 * Strips HTML tags and markdown syntax from text, returning plain text
 * @param {string} text - The text that may contain HTML or markdown
 * @returns {string} - Plain text without HTML or markdown
 */
export const stripHtmlMarkdown = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  // First, remove HTML tags
  let plainText = text.replace(/<[^>]*>/g, '');

  // Remove markdown syntax
  // Headers (# ## ###)
  plainText = plainText.replace(/^#{1,6}\s+/gm, '');

  // Bold/italic (**text** or *text*)
  plainText = plainText.replace(/\*\*(.*?)\*\*/g, '$1');
  plainText = plainText.replace(/\*(.*?)\*/g, '$1');

  // Code blocks (`code` or ```code```)
  plainText = plainText.replace(/```[\s\S]*?```/g, '');
  plainText = plainText.replace(/`([^`]+)`/g, '$1');

  // Links [text](url)
  plainText = plainText.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Images ![alt](url)
  plainText = plainText.replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1');

  // Lists (- item or * item or 1. item)
  plainText = plainText.replace(/^[\s]*[-*+]\s+/gm, '');
  plainText = plainText.replace(/^[\s]*\d+\.\s+/gm, '');

  // Blockquotes (> text)
  plainText = plainText.replace(/^>\s+/gm, '');

  // Horizontal rules (--- or ***)
  plainText = plainText.replace(/^[\s]*[-*_]{3,}[\s]*$/gm, '');

  // Clean up extra whitespace and normalize line breaks
  plainText = plainText.replace(/\n\s*\n/g, '\n');
  plainText = plainText.replace(/\s+/g, ' ');

  return plainText.trim();
};
